import React from 'react';
import { statusConverterForWhiteBackground } from 'utils/statusConverter';
import classNames from 'classnames';
import moment from 'moment';
import { isNumber } from 'utils/utils';


const columnData = (statusCode, flag) => {
  return {
    logIdx: {
      colWidth: '50px',
      th: <th rowSpan={2}>No.</th>,
      td: (props) => {
        return <td>{props.index + 1}</td>;
      },
    },
    areaNo: {
      colWidth: '200px',
      th: <th>설비번호</th>,
      td: (props) => {
        return <td>{props.areaNo}</td>;
      },
    },
    areaNm: {
      colWidth: '300px',
      th: <th>설비명</th>,
      td: (props) => {
        return <td>{props.areaNm}</td>;
      },
    },
    modelNo: {
      colWidth: '300px',
      th: <th rowSpan={2}>감지기No.</th>,
      td: (props) => {
        return <td>{props.modelNm}</td>;
      },
    },
    wind: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          풍속(m/s)
        </th>
      ),
      td: (props) => {
        return (<td className={classNames('data-text', props.wind_status)}>{props.wind}</td>)
      },
    },
    status: {
      colWidth: '130px',
      th: <th rowSpan={2}>상태</th>,
      td: (props) => {
        return (statusCode === '0' ? <td>{statusConverterForWhiteBackground(props.status)}</td> : <></>)
      },
    },
    battery: {
      colWidth: '130px',
      th: <th rowSpan={2}>Battery잔량</th>,
      td: (props) => {
        return <td>{Math.floor(props.battery)} %</td>;
      },
    },
    rgstDt: {
      colWidth: '400px',
      th: <th rowSpan={2}>측정시간</th>,
      td: (props) => {
        return <td>{props.rgstDt && moment(props.rgstDt).format('YYYY-MM-DD HH:mm:ss')}</td>;
      },
    },
  };
}

export default columnData;
